const getElement = el => el instanceof Element && el || el && el.$el && el.$el instanceof Element && el.$el || undefined;
const getStyle = el => {
  const __el = getElement(el);
  return __el && (typeof window.getComputedStyle === 'function' && window.getComputedStyle(__el, null) || __el.currentStyle);
}
const getWidth = el => {
  const __el = getElement(el);
  return __el && parseFloat(String(getStyle(__el).width).replace(/px/g, ''), 10) || 0;
}
const getHeight = el => {
  const __el = getElement(el);
  return __el && parseFloat(String(getStyle(__el).height).replace(/px/g, ''), 10) || 0;
}
export default {
  data() {
    return {
      currentDocumentTitle: document.title,
      backRouterName: ''
    };
  },
  methods: {
    //  获取 document
    getElement,
    //  获取元素样式
    getStyle,
    //  获取元素宽度
    getWidth,
    //  获取元素高度
    getHeight
  }
}
